import styled from "styled-components";
import { display, flexbox, layout, position } from "styled-system";
import { resolvePropValue } from "../../../functions/resolvePropValue";
import { SpaceProps } from "./Space.types";

export const StyledSpace = styled.div<SpaceProps>`
	margin-block-start: 0;
	margin-block-end: 0;
	margin-inline-start: 0;
	margin-inline-end: 0;

	${display}
	${layout}
  ${flexbox}
  ${position}

  ${({ theme, ...props }) => {
		const propArray = (
			spaceFor: "margin" | "padding",
			axis: "X" | "Y",
			position: "Top" | "Right" | "Bottom" | "Left"
		): string[] => {
			return [`${spaceFor}${position}`, `${spaceFor}${axis}`, spaceFor];
		};

		const spaceUnit = (token?: string): string | undefined => {
			return token ? theme.space[token] : undefined;
		};

		const [rowGap, columnGap] = props.gap
			? props.gap.split(" ")
			: [undefined, undefined];

		const gap =
			rowGap && columnGap
				? `${theme.space[rowGap]} ${theme.space[columnGap]}`
				: rowGap
				? `${theme.space[rowGap]}`
				: undefined;

		return {
			marginTop: spaceUnit(
				resolvePropValue(props, propArray("margin", "Y", "Top"))
			),
			marginRight: spaceUnit(
				resolvePropValue(props, propArray("margin", "X", "Right"))
			),
			marginBottom: spaceUnit(
				resolvePropValue(props, propArray("margin", "Y", "Bottom"))
			),
			marginLeft: spaceUnit(
				resolvePropValue(props, propArray("margin", "X", "Left"))
			),
			paddingTop: spaceUnit(
				resolvePropValue(props, propArray("padding", "Y", "Top"))
			),
			paddingRight: spaceUnit(
				resolvePropValue(props, propArray("padding", "X", "Right"))
			),
			paddingBottom: spaceUnit(
				resolvePropValue(props, propArray("padding", "Y", "Bottom"))
			),
			paddingLeft: spaceUnit(
				resolvePropValue(props, propArray("padding", "X", "Left"))
			),
			gap,
		};
	}}
`;

export default StyledSpace;
